export class SpecieModel {
    specie_index: number
    specie_name: string

    constructor(
        specie_index: number,
        specie_name: string
    ) {
        this.specie_index = specie_index
        this.specie_name = specie_name
    }
}